import {
  identify as amplitudeIdentify,
  Identify,
  init as amplitudeInit,
  setUserId as amplitudeSetUserId,
  track as amplitudeTrack,
} from '@amplitude/analytics-browser';
import { isBetaDomain, isProdEnvironment } from 'utils/environment';

let amplitudeReady = false;
let initializedUserId: string | null = null;

export function initAmplitude(): void {
  if (amplitudeReady) return;
  const apiKey = import.meta.env.REACT_APP_AMPLITUDE_API_KEY;

  if (!apiKey) return;

  // Only initialize Amplitude in production (non-beta) or when dev events are enabled
  const shouldInitialize = isProdEnvironment() && !isBetaDomain;

  if (!shouldInitialize) return;

  try {
    amplitudeInit(apiKey, undefined, {
      defaultTracking: false,
    });

    amplitudeReady = true;
  } catch (err) {
    if (import.meta.env.MODE === 'development') {
      console.warn('Amplitude init error', err);
    }
  }
}

export function isAmplitudeReady(): boolean {
  return amplitudeReady;
}

export function ensureAmplitudeUser(userId?: number, schoolId?: number): void {
  if (!amplitudeReady || !userId) return;
  // Amplitude requires user_id to be minimum 5 characters
  const uid = String(userId).padStart(5, '0');

  if (initializedUserId === uid) return; // avoid re-identify same user
  amplitudeSetUserId(uid);
  initializedUserId = uid;

  if (schoolId) {
    const identify = new Identify();

    identify.set('school_id', schoolId);
    amplitudeIdentify(identify);
  }
}

export function trackAmplitudeEvent(
  eventName: string,
  props: Record<string, unknown>
): void {
  if (!amplitudeReady) return;

  try {
    amplitudeTrack(eventName, props);
  } catch (err) {
    if (import.meta.env.MODE === 'development') {
      console.warn('Amplitude track failed', err);
    }
  }
}
